import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./TonMatchInfoModal.module.scss"

const modalType = "tonMatchInfo"

export const TonMatchInfoModal: FC = () => {
  const { modal } = useModal(modalType)
  const { t } = useTranslation()

  const handleClose = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.TonMatchInfoModal)}
      body={{ className: styles.TonMatchInfoModal_body }}
    >
      <Modal.StoneFlexContainer
        className={styles.TonMatchInfoModal_container}
        styles="ton"
        content={{ className: styles.TonMatchInfoModal_content }}
        outside={
          <div className={clsx(styles.TonMatchInfoModal_footerButtons)}>
            <Button
              className={clsx(styles.TonMatchInfoModal_footerButtons_item)}
              styles="green"
              onClick={handleClose}
            >
              {t("button.close")}
            </Button>
          </div>
        }
      >
        <OutlinedText className={clsx(styles.TonMatchInfoModal_title)}>
          {t("playForTon.tonMatchInfoModal.title")}
        </OutlinedText>
        <ul className={clsx(styles.TonMatchInfoModal_list)}>
          {Array.from({ length: 6 }).map((_, index) => (
            <li key={index}>
              {t(`playForTon.tonMatchInfoModal.text.${index}`)}
            </li>
          ))}
        </ul>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
